import { useClientWidth } from './use-user-dimention'

const breakPoint = 640

export const useIsMobile = () => {
  const width = useClientWidth()
  return width < breakPoint
}